import React,{useState,useEffect} from 'react';
import './Filterside.css';
import gallery from '../../assets/gallery.png';
import gallery1 from '../../assets/gallery(1).png';
import gallery2 from '../../assets/gallery(2).png';
import react from '../../assets/react.png';
import { getWithTokenAPI } from '../../util/Api';
import { useSelector } from 'react-redux';

const FilterSidebar = ({ isVisible }) => {
  const categories = [
    { name: 'Fresh Fruit', count: 134 },
    { name: 'Vegetables', count: 150 },
    { name: 'Cooking', count: 54 },
    { name: 'Snacks', count: 47 },
    { name: 'Beverages', count: 43 },
    { name: 'Beauty & Health', count: 38 },
    { name: 'Bread & Bakery', count: 15 }
  ];
  const accessToken = useSelector((state) => state.auth?.auth?.access_token);


  const tags = [
    { name: 'Healthy', active: false },
    { name: 'Low Fat', active: false },
    { name: 'Vegetarian', active: false },
    { name: 'Organic', active: false },
    { name: 'Gluten Free', active: false },
    { name: 'Vegan', active: false },
    { name: 'Keto', active: false },
    { name: 'Dairy Free', active: false },
    { name: 'Sugar Free', active: false },
    { name: 'Protein', active: false }
  ];
    useEffect(() => {
          const fetchTags = async () => {
              if (!accessToken) return;
  
              try {
                  const response = await getWithTokenAPI(accessToken, '/tag/find-all');
                  if (response?.statusCode === 200) {
                      setTags(response.data?.tags || []);
                  }
              } catch (err) {
                  console.error("Error fetching tags:", err);
              } finally {
                  // setLoading(false);
              }
          };
  
          fetchTags();
      }, [accessToken]);
  const [tagsmy, setTags] = useState(tags);
  const toggleTag = (index) => {
    const newTags = [...tags];
    newTags[index].active = !newTags[index].active;
    setTags(newTags);
  };

  const selectAllTags = () => {
    const newTags = tags.map(tag => ({ ...tag, active: true }));
    setTags(newTags);
  };
  const image = [gallery, gallery1, gallery2];
  const recentPosts = [
    {
      title: 'Curabitur porttitor orci eget nequ accumsan.',
      date: 'Apr 25, 2021'
    },
    {
      title: 'Donec mattis arcu faucibus suscipit viverra.',
      date: 'Apr 25, 2021'
    },
    {
      title: 'Quisque posuere tempus rutrum. Integer velit ex.',
      date: 'Apr 25, 2021'
    }
  ];


  return (
    <>

      <div className={`filter-sidebar ${isVisible ? 'show' : 'hide'}`}>
        {/* Search Section */}
        <div className="search-section">
          <div className="input-field">
            <div className="search-icon-filter">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="#1A1A1A" strokeWidth="1.5" />
                <path d="M19 19L14.65 14.65" stroke="#1A1A1A" strokeWidth="1.5" />
              </svg>
            </div>
            <input type="text" placeholder="Search..." />
          </div>
          <div className="divider-line"></div>
        </div>

        {/* Top Categories */}
        <div className="section-filter">
          <h3 className="section-title">Top Categories</h3>
          <div className="categories-list">
            {categories.map((category, index) => (
              <div key={index} className="category-item-filter">
                <span>{category.name}</span>
                <span className="category-count">({category.count})</span>
              </div>
            ))}
          </div>
          <div className="divider-line"></div>
        </div>

        {/* Popular Tags */}
        <div className="section-filter">
          <h3 className="section-title">Popular Tag</h3>
          {/* <button className="select-all-btn" onClick={selectAllTags}>Select All</button> */}
          <div className="tags-container">
            {tagsmy.map((tag, index) => (
              <div
                key={index}
                className={`tag ${tag.active ? 'active' : ''}`}
                onClick={() => toggleTag(index)}
              >
                {tag.name}
              </div>
            ))}
          </div>
          <div className="divider-line"></div>
        </div>

        {/* Our Gallery */}
        <div className="section-filter">
          <h3 className="section-title">Our Gallery</h3>
          <div className="gallery-grid">
            {[...Array(6)].map((_, index) => (
              <div key={index} className="gallery-item">
                <img src={gallery} alt='gallery' />
              </div>
            ))}
          </div>
          <div className="divider-line"></div>
        </div>

        {/* Recently Added */}
        <div className="section-filter">
          <h3 className="section-title">Recently Added</h3>
          <div className="recent-posts">
            {recentPosts.map((post, index) => (
              <div key={index} className="post-item">
                <div className="post-image">
                  <img src={react} alt='image' />
                </div>
                <div className="post-info">
                  <h4 className="post-title">{post.title}</h4>
                  <div className="post-date">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                      <path d="M14.25 3H3.75C2.92157 3 2.25 3.67157 2.25 4.5V15C2.25 15.8284 2.92157 16.5 3.75 16.5H14.25C15.0784 16.5 15.75 15.8284 15.75 15V4.5C15.75 3.67157 15.0784 3 14.25 3Z" stroke="#CC0000" strokeWidth="1.5" />
                      <path d="M12 1.5V4.5" stroke="#CC0000" strokeWidth="1.5" />
                      <path d="M6 1.5V4.5" stroke="#CC0000" strokeWidth="1.5" />
                      <path d="M2.25 7.5H15.75" stroke="#CC0000" strokeWidth="1.5" />
                    </svg>
                    <span>{post.date}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterSidebar;
